import React from "react";
import styles from "../ResourcesPlanner.module.scss";
import { ALLOCATION_BAR_HEIGHT, BAR_TOP_OFFSET, LANE_PITCH } from "../constants";
import { getTimelineStatusColor } from "../../dashboard/utils/helper";
import { TimelineTaskIcons } from "../../../helpers/utils";

/**
 * One allocation bar. It carries which allocation it is (data attributes) and which part of it a press lands on, and
 * has no handlers of its own: the timeline listens once for all bars, so a bar is a few elements and nothing more.
 */
function AllocationBar({ allocation, lane, originDay, dayWidth }) {
  const left = (allocation.startDay - originDay) * dayWidth;
  const width = (allocation.endDay - allocation.startDay + 1) * dayWidth;
  const renderIcon = TimelineTaskIcons[allocation.status];

  return (
    <div
      className={`${styles.allocationBar} ${styles.barIn} ${getTimelineStatusColor(allocation.status, 0, false)}`}
      data-bar=""
      data-r={allocation.resourceId}
      data-t={allocation.taskId}
      style={{ left: left + 2, width: width - 2, top: lane * LANE_PITCH + BAR_TOP_OFFSET, height: ALLOCATION_BAR_HEIGHT }}
    >
      <div className="resize-handle-timeline absolute left-0 top-0 w-3 h-full cursor-ew-resize z-30" data-handle="left" />
      <div className={styles.barContent} data-handle="move">
        {width > 30 && renderIcon && <div className="flex-shrink-0 w-3 h-3 flex items-center justify-center mr-1">{renderIcon()}</div>}
        <span className={styles.barLabel}>{allocation.name}</span>
      </div>
      <div className="resize-handle-timeline absolute right-0 top-0 w-3 h-full cursor-ew-resize z-30" data-handle="right" />
    </div>
  );
}

export default React.memo(AllocationBar);
